module.exports = __webpack_public_path__ + "3e8b449aaae4d1e24c943061f10f71dd.svg";